import React, { useEffect, useState } from 'react';
import { Spinner } from 'phosphor-react';

export default ({ size = 42, delay = null }) => {
  const [show, setShow] = useState(delay == null);
  useEffect(() => {
    if (!delay) return;
    let timeout = setTimeout(() => setShow(true), delay);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    show && (
      <Spinner size={size} className="spin">
        {/* <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="2.25s"
          from="0 0 0"
          to="360 0 0"
          repeatCount="indefinite"
        /> */}
      </Spinner>
    )
  );
};
